import { v4 as uuidV4, v5 as uuidV5 } from 'uuid';

const uuidToHex = (uuid: string): string => uuid.replaceAll('-', '');

export const uuid4InHex = (): string => uuidToHex(uuidV4());

export const uuid5InHex = (name: string, namespace: string): string => uuidToHex(uuidV5(name, namespace));
